
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35555",
  depVersions: {
  "documents-public-ui": "static-1.35555",
  "atom": "static-1.5555",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2968",
  "client-types": "static-1.511",
  "cssUtils": "static-1.1105",
  "customer-data-filters-ui": "static-1.41396",
  "customer-data-objects": "static-1.8188",
  "customer-data-property-utils": "static-1.8533",
  "documents-lib": "static-1.35560",
  "emoji-mart": "static-3.7",
  "flux-actions": "static-1.381",
  "FormsCommonComponents": "static-1.86851",
  "FormUrlGenerator": "static-2.5195",
  "foundations-theming-specialty": "static-1.2687",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6075",
  "hs-test-utils": "static-1.8521",
  "hub-http": "static-1.6689",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12277",
  "HubStyleTokens": "static-2.11970",
  "I18n": "static-7.1709",
  "icons": "static-2.703",
  "jasmine-immutable": "static-1.3420",
  "jasmine-runner": "static-1.6935",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7629",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3366",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5862",
  "quartz": "static-1.7667",
  "react": "static-7.203",
  "react-dlb": "static-1.94",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17220",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5660",
  "react-virtualized": "static-2.112",
  "reference-resolvers": "static-1.8666",
  "reference-resolvers-lite": "static-1.8595",
  "reporting-data": "static-1.69379",
  "reporting-reports": "static-1.69055",
  "reporting-snowflake": "static-1.57995",
  "reporting-testing-lib": "static-1.11312",
  "reporting-visualizations": "static-1.61453",
  "reselect": "static-3.16",
  "sales-content-partitioning": "static-1.9443",
  "sanitize": "static-1.4957",
  "sanitize-text": "static-1.8641",
  "SharedI18nStrings": "static-1.188",
  "SharedLegalStrings": "static-1.2211",
  "signup-constants": "static-1.19957",
  "signup-ui-url-generator": "static-2.8520",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5242",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5231",
  "ui-addon-form-validation": "static-1.11348",
  "ui-asset-management-lib": "static-1.11583",
  "ui-images": "static-2.1277",
  "UIComponents": "static-3.8916",
  "usage-tracker": "static-1.7807",
  "usage-tracker-container": "static-1.7797",
  "usage-tracker-core": "static-1.7657",
  "viral-links-lib": "static-1.7564",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10123",
  "foundations-components": "static-1.8763",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1445",
  "quartz-core": "static-1.6886",
  "quick-fetch": "static-1.4235",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "rpc-client-utils": "static-1.5152",
  "ui-addon-i18n": "static-1.11628",
  "ui-addon-upgrades": "static-9.18549",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3944",
  "quartz-webpack": "static-1.3891",
  "foundations-assets": "static-1.5370",
  "foundations-theming": "static-1.4971",
  "hub-http-janus": "static-1.908",
  "hub-http-shared-msw-handlers": "static-1.10920",
  "hubspotter-http": "static-1.4979",
  "trellis-components": "static-1.3124",
  "trellis-migration-context": "static-1.63",
  "sassPrefix": "static-1.371",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44128",
  "customer-data-filters-ui-msw-helpers": "static-1.23831",
  "customer-data-objects-ui-components": "static-1.13518",
  "customer-data-reference-ui-components": "static-1.13658",
  "customer-data-ui-utilities": "static-1.10314",
  "events-data-lib": "static-1.728",
  "framework-builder-read-service-client": "static-1.4339",
  "hs-resources": "static-1.667",
  "immer": "static-1.105",
  "inbound-db-meta-service-client": "static-1.3778",
  "inbound-db-properties-service-client": "static-1.4155",
  "multi-account-reference-resolvers": "static-1.1492",
  "onboarding-tours": "static-1.17410",
  "pulse": "static-1.1131",
  "reporting-datasets-permissions-lib": "static-1.14786",
  "segments-client-types": "static-1.12185",
  "stylex": "static-1.46",
  "trellis-assets": "static-1.3105",
  "trellis-theming": "static-1.1492",
  "ui-addon-teams": "static-1.22020",
  "quartz-auth": "static-1.1342",
  "ui-business-units-lib": "static-1.9578",
  "usage-tracker-session-replay": "static-1.5493",
  "ai-components-ui-library": "static-1.10039",
  "ContentUtils": "static-1.69494",
  "customer-data-properties": "static-1.53072",
  "forms-ai-lib": "static-1.4995",
  "forms-utils-lib": "static-1.13350",
  "foundations-components-test-utils": "static-1.6246",
  "react-dnd-compat": "static-1.5092",
  "react-tinymce": "static-1.56285",
  "tinymce-config": "static-2.55411",
  "ui-gdpr-components": "static-1.10656",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3956",
  "HeadJS": "static-2.823",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3632",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.404",
  "ui-fonts": "static-1.1232",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4790",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.183",
  "quartz-head": "static-1.1332",
  "web-vitals": "static-1.19",
  "batch-promise": "static-1.2031",
  "external-options-client-types": "static-1.4443",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1342",
  "frontend-preferences-client": "static-1.8403",
  "graphql": "static-1.93",
  "persist-promise": "static-1.4188",
  "reporting-client-types": "static-1.2843",
  "apollo-stack-hubspot": "static-3.99",
  "hubspot-apollo-client": "static-1.5365",
  "foundations-components-legacy": "static-1.1788",
  "quartz-routing": "static-1.1097",
  "hs-story-utils": "static-1.9910",
  "react-flip-move": "static-1.83",
  "nested-table": "static-1.715",
  "seat-types-lib": "static-1.1069",
  "timezone-utils": "static-2.5712",
  "react-create-root-preference": "static-1.104",
  "bend-plugin-foundations-components": "static-1.5032",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "tanstack-table": "static-1.66",
  "opentelemetry-fe-types": "static-1.274",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.649",
  "quartz-test": "static-1.1342",
  "quartz-tracking": "static-1.1046",
  "bend-plugin-chirp-manifest": "static-1.562",
  "chirp-fetch": "static-1.2387",
  "merchandise-lib": "static-1.286",
  "purchase-motions-components": "static-1.6642",
  "ts-schema": "static-1.4398",
  "bender-build-tools": "static-1.3600",
  "bend-plugin-foundations-theming": "static-1.3454",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "restore-request-side-panel-lib": "static-1.2041",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5070",
  "conditional-properties-service-client": "static-1.4117",
  "crm-pipelines-api-client-types": "static-1.4447",
  "event-emitter": "static-1.1444",
  "fdsr-migration-layer": "static-1.494",
  "multi-currency-client-types": "static-1.4011",
  "getting-started-shared-tasks": "static-1.19581",
  "growth-data-modal": "static-1.6146",
  "growth-onboarding-confetti": "static-1.3541",
  "growth-onboarding-next-action-utils": "static-1.3001",
  "navigation-components": "static-1.19185",
  "nest": "static-1.718",
  "onboarding-tours-client": "static-1.5625",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-react": "static-3.10761",
  "ui-shepherd-tracker": "static-1.8142",
  "ui-universal-auth": "static-1.9761",
  "user-context": "static-1.5536",
  "bend-plugin-pulse": "static-1.634",
  "fast-json-patch": "static-1.74",
  "crm-index-associations-lib": "static-1.6931",
  "stylex-utils": "static-1.176",
  "hubspotter-http-shared-msw-handlers": "static-1.10918",
  "magpie-lib": "static-1.5913",
  "navigation-messaging": "static-1.8512",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23930",
  "copilot-toolkit": "static-1.12166",
  "cms-field-types": "static-1.5293",
  "content-icons-ui": "static-1.2464",
  "integrations-lib": "static-1.17447",
  "calling-global-api": "static-1.66218",
  "calling-internal-common": "static-1.31808",
  "calling-lifecycle-internal": "static-1.67600",
  "calling-lifecycle-messages": "static-1.59892",
  "commerce-products-lib": "static-1.10938",
  "crm-index-visualization-core": "static-1.4768",
  "crm-links": "static-1.6794",
  "customer-data-properties-shared-msw-handlers": "static-1.10247",
  "file-manager-components": "static-1.24861",
  "formula-editor": "static-1.15022",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1114",
  "object-builder-ui-client": "static-1.50069",
  "pipeline-validation-client-types": "static-1.4286",
  "property-value-citations": "static-1.3686",
  "smart-data-capture-core": "static-1.492",
  "smart-property-lib": "static-1.8677",
  "tiered-pricing": "static-1.2296",
  "topics-actions-lib": "static-1.665",
  "trellis-ext-i18n": "static-1.1401",
  "trial-components-library": "static-1.14391",
  "ui-addon-iframeable": "static-1.9558",
  "zustand": "static-1.89",
  "final-form": "static-1.83",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.82",
  "rich-text-lib": "static-1.20568",
  "tinymce-themes": "static-1.57381",
  "data-token-picker": "static-1.17148",
  "hub-http-contrib": "static-1.3515",
  "interframe": "static-3.5224",
  "tinymce-data": "static-1.41496",
  "tinymce-plugins": "static-1.58525",
  "ui-addon-sales-email": "static-1.5684",
  "hubspot-apollo-cache": "static-1.824",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.633",
  "opentelemetry-web": "static-1.23",
  "onboarding-scopes": "static-1.6935",
  "purchase-motions-api": "static-1.6645",
  "onboarding-data-sync-lib": "static-1.2852",
  "growth-onboarding-next-action-components": "static-1.3029",
  "user-context-client": "static-1.4992",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5373",
  "reactive-lib": "static-1.1202",
  "simple-logging-lib": "static-1.3534",
  "custom-vendor-connection-lib": "static-1.325",
  "unified-auth-core-lib": "static-1.1557",
  "getting-started-shared-tasks-store": "static-1.18699",
  "nav-meta": "static-1.30822",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2216",
  "integrations-error-boundary-lib": "static-1.14862",
  "integrations-tracking-lib": "static-1.6103",
  "native-integrations-shared-strings": "static-1.8246",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10853",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31815",
  "shared-worker-versioning": "static-1.11525",
  "calling-usage-tracker": "static-1.7022",
  "customer-data-tracking": "static-1.7353",
  "voice-sms-access-library": "static-1.2478",
  "commerce-permissions": "static-1.1267",
  "growth-payments-core": "static-1.26521",
  "products-iframe-lib": "static-1.8934",
  "products-ui-components-shared-msw-handlers": "static-1.11302",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11003",
  "sales-views-client-types": "static-1.4740",
  "framework-data-schema-resolvers": "static-1.7375",
  "location-customization-utils-lib": "static-1.10440",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4624",
  "poll-commands": "static-1.3960",
  "video-components-external": "static-1.12449",
  "video-data-lib": "static-1.36107",
  "bark-lib": "static-1.17014",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6378",
  "react-codemirror": "static-1.11124",
  "data-agent-kit": "static-1.932",
  "data-agent-test-utils": "static-1.476",
  "data-agent-utils": "static-1.945",
  "feedback-loader": "static-1.30074",
  "fsm": "static-1.4240",
  "policy-lib": "static-1.7287",
  "react-colorpicker": "static-2.10692",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11066",
  "embedded-academy-lib": "static-1.16030",
  "hubs-service-types": "static-1.1751",
  "nudge-client-utils": "static-1.3434",
  "salesImages": "static-1.740",
  "FileManagerLib": "static-1.40501",
  "NamespacedHubStyle": "static-2.9371",
  "FileManagerCore": "static-1.40360",
  "content-assistance-lib": "static-1.8434",
  "layout-dnd-components": "static-1.13242",
  "layout-dnd-utils": "static-1.12217",
  "ui-addon-emoji-picker": "static-1.10346",
  "ui-brand-identity-lib": "static-1.16970",
  "InboxConnectUtils": "static-4.15859",
  "meetings-connect-utils-lib": "static-1.8101",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1194",
  "breeze-engine-core": "static-1.1494",
  "highlight.js": "static-1.90",
  "universal-page-editor-lib": "static-1.3495",
  "calling-orchestration-schema": "static-1.37255",
  "ui-addon-opt": "static-4.8894",
  "framework-data-schema-quick-fetch": "static-1.7280",
  "crm-record-cards-service-types": "static-1.3871",
  "content-media-composition-data-lib": "static-1.13621",
  "content-media-compositions": "static-2.17628",
  "media-bridge-lib": "static-1.19655",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16685",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4981",
  "enrichment-settings-lib": "static-1.250",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15491",
  "nudge-custom-function-registry": "static-1.3191",
  "nudge-renderer-utils": "static-1.3510",
  "whisper-core-api": "static-1.7653",
  "audio-components": "static-1.6584",
  "FileManagerImages": "static-1.38012",
  "video-components": "static-1.14451",
  "breeze-artifacts-sdk": "static-1.997",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4997",
  "video-embed": "static-1.36941",
  "ui-addon-video-player": "static-1.9106",
  "ui-coaching-tips": "static-1.29591",
  "ContentData": "static-1.69569",
  "layout-data-lib": "static-1.10542",
  "crm-record-cards-client": "static-1.76",
  "academy-service-client": "static-1.4175",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4879",
  "trellis-ecosystem": "static-1.7863",
  "ui-addon-react-router-dom": "static-1.10007",
  "wootric-nps": "static-1.7300",
  "social-insights-client-types": "static-1.22947",
  "outpost": "static-1.4610",
  "growth-onboarding-feedback-components": "static-1.7063",
  "advanced-menus-core": "static-1.15829",
  "advanced-menus-lib": "static-1.12578",
  "ExportDialog": "static-6.10856",
  "ui-memberships-settings-lib": "static-1.35217",
  "marketplace-ui-apps-core": "static-1.19582",
  "marketplace-ui-common": "static-1.21050",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15828",
  "simple-menus-lib": "static-1.17345",
  "settings-ui-lib": "static-1.13010",
  "developer-experience-shared-components": "static-1.11022",
  "immutable-less": "static-1.5135",
  "marketplace-ui-client-types": "static-1.18457",
  "ui-addon-integrations-directory-panel": "static-2.8436",
  "ui-extensibility-client-types": "static-1.4398",
  "ai-settings-ui-library": "static-1.8604",
  "ui-product-approvals-common": "static-1.1600",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4620",
  "simple-data-table": "static-1.3839"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35555",
  "atom": "/atom/static-1.5555",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2968",
  "client-types": "/client-types/static-1.511",
  "cssUtils": "/cssUtils/static-1.1105",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41396",
  "customer-data-objects": "/customer-data-objects/static-1.8188",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8533",
  "documents-lib": "/documents-lib/static-1.35560",
  "emoji-mart": "/emoji-mart/static-3.7",
  "flux-actions": "/flux-actions/static-1.381",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86851",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5195",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2687",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6075",
  "hs-test-utils": "/hs-test-utils/static-1.8521",
  "hub-http": "/hub-http/static-1.6689",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12277",
  "HubStyleTokens": "/HubStyleTokens/static-2.11970",
  "I18n": "/I18n/static-7.1709",
  "icons": "/icons/static-2.703",
  "jasmine-immutable": "/jasmine-immutable/static-1.3420",
  "jasmine-runner": "/jasmine-runner/static-1.6935",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7629",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3366",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5862",
  "quartz": "/quartz/static-1.7667",
  "react": "/react/static-7.203",
  "react-dlb": "/react-dlb/static-1.94",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17220",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5660",
  "react-virtualized": "/react-virtualized/static-2.112",
  "reference-resolvers": "/reference-resolvers/static-1.8666",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8595",
  "reporting-data": "/reporting-data/static-1.69379",
  "reporting-reports": "/reporting-reports/static-1.69055",
  "reporting-snowflake": "/reporting-snowflake/static-1.57995",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11312",
  "reporting-visualizations": "/reporting-visualizations/static-1.61453",
  "reselect": "/reselect/static-3.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9443",
  "sanitize": "/sanitize/static-1.4957",
  "sanitize-text": "/sanitize-text/static-1.8641",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2211",
  "signup-constants": "/signup-constants/static-1.19957",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5242",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5231",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11583",
  "ui-images": "/ui-images/static-2.1277",
  "UIComponents": "/UIComponents/static-3.8916",
  "usage-tracker": "/usage-tracker/static-1.7807",
  "usage-tracker-container": "/usage-tracker-container/static-1.7797",
  "usage-tracker-core": "/usage-tracker-core/static-1.7657",
  "viral-links-lib": "/viral-links-lib/static-1.7564",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10123",
  "foundations-components": "/foundations-components/static-1.8763",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1445",
  "quartz-core": "/quartz-core/static-1.6886",
  "quick-fetch": "/quick-fetch/static-1.4235",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.5152",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11628",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18549",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3944",
  "quartz-webpack": "/quartz-webpack/static-1.3891",
  "foundations-assets": "/foundations-assets/static-1.5370",
  "foundations-theming": "/foundations-theming/static-1.4971",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10920",
  "hubspotter-http": "/hubspotter-http/static-1.4979",
  "trellis-components": "/trellis-components/static-1.3124",
  "trellis-migration-context": "/trellis-migration-context/static-1.63",
  "sassPrefix": "/sassPrefix/static-1.371",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44128",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23831",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13518",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13658",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10314",
  "events-data-lib": "/events-data-lib/static-1.728",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4339",
  "hs-resources": "/hs-resources/static-1.667",
  "immer": "/immer/static-1.105",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3778",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4155",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1492",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "pulse": "/pulse/static-1.1131",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14786",
  "segments-client-types": "/segments-client-types/static-1.12185",
  "stylex": "/stylex/static-1.46",
  "trellis-assets": "/trellis-assets/static-1.3105",
  "trellis-theming": "/trellis-theming/static-1.1492",
  "ui-addon-teams": "/ui-addon-teams/static-1.22020",
  "quartz-auth": "/quartz-auth/static-1.1342",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9578",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5493",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10039",
  "ContentUtils": "/ContentUtils/static-1.69494",
  "customer-data-properties": "/customer-data-properties/static-1.53072",
  "forms-ai-lib": "/forms-ai-lib/static-1.4995",
  "forms-utils-lib": "/forms-utils-lib/static-1.13350",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6246",
  "react-dnd-compat": "/react-dnd-compat/static-1.5092",
  "react-tinymce": "/react-tinymce/static-1.56285",
  "tinymce-config": "/tinymce-config/static-2.55411",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3956",
  "HeadJS": "/HeadJS/static-2.823",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3632",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.404",
  "ui-fonts": "/ui-fonts/static-1.1232",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4790",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.183",
  "quartz-head": "/quartz-head/static-1.1332",
  "web-vitals": "/web-vitals/static-1.19",
  "batch-promise": "/batch-promise/static-1.2031",
  "external-options-client-types": "/external-options-client-types/static-1.4443",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1342",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8403",
  "graphql": "/graphql/static-1.93",
  "persist-promise": "/persist-promise/static-1.4188",
  "reporting-client-types": "/reporting-client-types/static-1.2843",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5365",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1788",
  "quartz-routing": "/quartz-routing/static-1.1097",
  "hs-story-utils": "/hs-story-utils/static-1.9910",
  "react-flip-move": "/react-flip-move/static-1.83",
  "nested-table": "/nested-table/static-1.715",
  "seat-types-lib": "/seat-types-lib/static-1.1069",
  "timezone-utils": "/timezone-utils/static-2.5712",
  "react-create-root-preference": "/react-create-root-preference/static-1.104",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5032",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "tanstack-table": "/tanstack-table/static-1.66",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.274",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.649",
  "quartz-test": "/quartz-test/static-1.1342",
  "quartz-tracking": "/quartz-tracking/static-1.1046",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.562",
  "chirp-fetch": "/chirp-fetch/static-1.2387",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "purchase-motions-components": "/purchase-motions-components/static-1.6642",
  "ts-schema": "/ts-schema/static-1.4398",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3454",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2041",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5070",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4117",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4447",
  "event-emitter": "/event-emitter/static-1.1444",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.494",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4011",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19581",
  "growth-data-modal": "/growth-data-modal/static-1.6146",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3541",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3001",
  "navigation-components": "/navigation-components/static-1.19185",
  "nest": "/nest/static-1.718",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10761",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8142",
  "ui-universal-auth": "/ui-universal-auth/static-1.9761",
  "user-context": "/user-context/static-1.5536",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.634",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6931",
  "stylex-utils": "/stylex-utils/static-1.176",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10918",
  "magpie-lib": "/magpie-lib/static-1.5913",
  "navigation-messaging": "/navigation-messaging/static-1.8512",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23930",
  "copilot-toolkit": "/copilot-toolkit/static-1.12166",
  "cms-field-types": "/cms-field-types/static-1.5293",
  "content-icons-ui": "/content-icons-ui/static-1.2464",
  "integrations-lib": "/integrations-lib/static-1.17447",
  "calling-global-api": "/calling-global-api/static-1.66218",
  "calling-internal-common": "/calling-internal-common/static-1.31808",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67600",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59892",
  "commerce-products-lib": "/commerce-products-lib/static-1.10938",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4768",
  "crm-links": "/crm-links/static-1.6794",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10247",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "formula-editor": "/formula-editor/static-1.15022",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1114",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50069",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4286",
  "property-value-citations": "/property-value-citations/static-1.3686",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.492",
  "smart-property-lib": "/smart-property-lib/static-1.8677",
  "tiered-pricing": "/tiered-pricing/static-1.2296",
  "topics-actions-lib": "/topics-actions-lib/static-1.665",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1401",
  "trial-components-library": "/trial-components-library/static-1.14391",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9558",
  "zustand": "/zustand/static-1.89",
  "final-form": "/final-form/static-1.83",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "rich-text-lib": "/rich-text-lib/static-1.20568",
  "tinymce-themes": "/tinymce-themes/static-1.57381",
  "data-token-picker": "/data-token-picker/static-1.17148",
  "hub-http-contrib": "/hub-http-contrib/static-1.3515",
  "interframe": "/interframe/static-3.5224",
  "tinymce-data": "/tinymce-data/static-1.41496",
  "tinymce-plugins": "/tinymce-plugins/static-1.58525",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5684",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.824",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.633",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "onboarding-scopes": "/onboarding-scopes/static-1.6935",
  "purchase-motions-api": "/purchase-motions-api/static-1.6645",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2852",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3029",
  "user-context-client": "/user-context-client/static-1.4992",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5373",
  "reactive-lib": "/reactive-lib/static-1.1202",
  "simple-logging-lib": "/simple-logging-lib/static-1.3534",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.325",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1557",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18699",
  "nav-meta": "/nav-meta/static-1.30822",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2216",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14862",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6103",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8246",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10853",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31815",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11525",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7022",
  "customer-data-tracking": "/customer-data-tracking/static-1.7353",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2478",
  "commerce-permissions": "/commerce-permissions/static-1.1267",
  "growth-payments-core": "/growth-payments-core/static-1.26521",
  "products-iframe-lib": "/products-iframe-lib/static-1.8934",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11302",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11003",
  "sales-views-client-types": "/sales-views-client-types/static-1.4740",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7375",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10440",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4624",
  "poll-commands": "/poll-commands/static-1.3960",
  "video-components-external": "/video-components-external/static-1.12449",
  "video-data-lib": "/video-data-lib/static-1.36107",
  "bark-lib": "/bark-lib/static-1.17014",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6378",
  "react-codemirror": "/react-codemirror/static-1.11124",
  "data-agent-kit": "/data-agent-kit/static-1.932",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.476",
  "data-agent-utils": "/data-agent-utils/static-1.945",
  "feedback-loader": "/feedback-loader/static-1.30074",
  "fsm": "/fsm/static-1.4240",
  "policy-lib": "/policy-lib/static-1.7287",
  "react-colorpicker": "/react-colorpicker/static-2.10692",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11066",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16030",
  "hubs-service-types": "/hubs-service-types/static-1.1751",
  "nudge-client-utils": "/nudge-client-utils/static-1.3434",
  "salesImages": "/salesImages/static-1.740",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9371",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "content-assistance-lib": "/content-assistance-lib/static-1.8434",
  "layout-dnd-components": "/layout-dnd-components/static-1.13242",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12217",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10346",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16970",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15859",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8101",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1194",
  "breeze-engine-core": "/breeze-engine-core/static-1.1494",
  "highlight.js": "/highlight.js/static-1.90",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3495",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37255",
  "ui-addon-opt": "/ui-addon-opt/static-4.8894",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7280",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "media-bridge-lib": "/media-bridge-lib/static-1.19655",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16685",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4981",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.250",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15491",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3191",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3510",
  "whisper-core-api": "/whisper-core-api/static-1.7653",
  "audio-components": "/audio-components/static-1.6584",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "video-components": "/video-components/static-1.14451",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.997",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4997",
  "video-embed": "/video-embed/static-1.36941",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9106",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29591",
  "ContentData": "/ContentData/static-1.69569",
  "layout-data-lib": "/layout-data-lib/static-1.10542",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.76",
  "academy-service-client": "/academy-service-client/static-1.4175",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4879",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7863",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10007",
  "wootric-nps": "/wootric-nps/static-1.7300",
  "social-insights-client-types": "/social-insights-client-types/static-1.22947",
  "outpost": "/outpost/static-1.4610",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7063",
  "advanced-menus-core": "/advanced-menus-core/static-1.15829",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12578",
  "ExportDialog": "/ExportDialog/static-6.10856",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35217",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15828",
  "simple-menus-lib": "/simple-menus-lib/static-1.17345",
  "settings-ui-lib": "/settings-ui-lib/static-1.13010",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11022",
  "immutable-less": "/immutable-less/static-1.5135",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8436",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4398",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8604",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1600",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4620",
  "simple-data-table": "/simple-data-table/static-1.3839"
}
};
